var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolandKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "#e94e0f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.973 34.246c4.67-3.517 11.125-2.612 14.73 2.159 3.777 4.979 3.022 12.292-1.683 16.331s-11.571 3.308-15.314-1.671a8.67 8.67 0 0 1-.412-.592l5.288-14.102-2.61-2.124zm9.923 10.586c.687-2.089-.343-4.387-2.266-5.188-1.957-.801-4.086.244-4.773 2.333s.343 4.387 2.266 5.188c1.957.766 4.086-.279 4.773-2.333zm-17.203-13.58-3.777 16.853-5.425-12.779-4.498-.696-1.751 8.914 4.532 3.204-.962 1.811c-1.305 2.437-3.296 4.353-5.631 5.502l-.172.905 6.661.696 1.339-9.332 4.292 10.133 5.013.766 7.52-20.092-7.142-5.885zm-32.208-.731-8.584-.07-5.494 10.934-1.648-7.452-6.867 1.532 5.631 20.927 5.7-1.532-1.167-5.606 12.293 4.91 1.202-1.811c-1.992-1.637-3.537-3.865-4.395-6.407l-6.215-1.079 9.546-14.346zm18.301 16.923c-1.683 3.134-4.807 5.328-8.515 5.502-5.837.279-11.022-4.422-11.4-10.551-.446-6.094 2.987-11.247 9.923-11.595 3.296-.174 6.352 1.288 8.447 3.656l-9.683 11.282s2.301 2.403 6.284-1.776l4.945 3.482zm-13.529-4.945 4.395-5.78c-4.189-1.846-6.833 2.612-4.395 5.78zM50.636 64.48c0 2.151 2.004 3.905 4.463 3.905s4.463-1.754 4.463-3.905-2.004-3.905-4.463-3.905c-2.496 0-4.463 1.754-4.463 3.905z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolandKeno);
export default __webpack_public_path__ + "static/media/poland_keno.39852bb53602f9639d380296ed79e640.svg";
export { ForwardRef as ReactComponent };